import BFLLink from "@repo/shared-ui/BFLLink";

export interface IConsentListItem {
  text: string;
}

export interface IConsentList {
  [key: string]: IConsentListItem;
}

export interface IBFLConsentModal {
  title: string;
  link: string;
  openInNewTab: string;
  note: string;
  para1: string;
  para2: string;
  list: IConsentList[];
}
interface IConsentProps {
  ssoContent?: IBFLConsentModal;
}

const BFLConsentModal = ({ ssoContent }: IConsentProps) => {
  const { link = "", note = "", para1 = "", para2 = "", list = [] } = ssoContent ?? {};
  const items = list.flatMap((group) => Object.values(group));

  const renderConsentText = (text: string) => {
    const match = text.match(/\(T&C\)/);
    if (!match) {
      return text;
    }
    const [before, after] = text.split(match[0]);

    return (
      <>
        {before}
        <BFLLink openInNewTab className="text-blue-600 underline hover:text-blue-800" href={link}>
          {match[0]}
        </BFLLink>
        {after}
      </>
    );
  };
  return (
    <>
      <p className="text-center text-sm leading-[16px] text-black">{para1}</p>

      <div className="bg-gray-150 mt-4 w-full space-y-2 rounded-md p-3">
        <p className="text-link-secondary">{note}:</p>
        <ul className="text-link-secondary list-inside list-disc space-y-1 text-sm">
          {items?.map((item: IConsentListItem, index: number) => (
            <li key={index} className="mb-2">
              {index === 0 ? renderConsentText(item?.text) : item?.text}
            </li>
          ))}
        </ul>
      </div>

      <p className="mt-4 text-center text-sm text-black">{para2}</p>
    </>
  );
};

export default BFLConsentModal;
